// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as SupSection from "./SupSection.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

var sizeHalf = "430";

function SupTacticians(Props) {
  var screenSize = ScreenAtom.use(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement(SupSection.make, {
                  children: null,
                  id: "set-update-tacticians",
                  title: "Tacticians"
                }, React.createElement(ContentSection.make, {
                      children: null
                    }, React.createElement("h3", {
                          className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                        }, "Project Vayne Unbound"), React.createElement("div", {
                          className: "flex flex-col md:flex-row justify-around items-center gap-8"
                        }, React.createElement("img", {
                              className: "rounded w-[320px] sm:w-[430px]",
                              height: sizeHalf,
                              src: "https://ap.tft.tools/img/cd14/project_vayne_unbound.png?w=" + sizeHalf,
                              width: sizeHalf
                            }), React.createElement("iframe", {
                              class: "rounded",
                              width: screenSize === /* Xs */5 ? "320" : "440",
                              height: screenSize === /* Xs */5 ? "180" : "247",
                              src: "https://www.youtube.com/embed/vZfg0R82Css?si=Iv0QnXfFDPvPskjv",
                              title: "Project Vayne Unbound",
                              frameborder: "0",
                              allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                              allowfullscreen: true
                            }))), React.createElement(ContentSection.make, {
                      className: "mt-6",
                      children: null
                    }, React.createElement("h3", {
                          className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                        }, "Chibi Forecast Janna"), React.createElement("div", {
                          className: "flex flex-col md:flex-row justify-around items-center gap-8"
                        }, React.createElement("img", {
                              className: "rounded w-[320px] sm:w-[430px]",
                              height: sizeHalf,
                              src: "https://ap.tft.tools/img/cd14/chibi_forecaster_janna.png?w=" + sizeHalf,
                              width: sizeHalf
                            }), React.createElement("iframe", {
                              class: "rounded",
                              width: screenSize === /* Xs */5 ? "320" : "440",
                              height: screenSize === /* Xs */5 ? "180" : "247",
                              src: "https://www.youtube.com/embed/9EHH4q0V5Eg?si=84Af948nsvYA3Foa",
                              title: "Chibi Forecast Janna",
                              frameborder: "0",
                              allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                              allowfullscreen: true
                            })))), React.createElement(SupSection.make, {
                  children: React.createElement(ContentSection.make, {
                        children: React.createElement("div", {
                              className: "grid grid-cols-1 md:grid-cols-2 justify-around items-center gap-8"
                            }, React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Cyber City Arena"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/arena_cyber_city.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Project Edgefall Arena"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/arena_project_edgefall.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })))
                      }),
                  id: "set-update-arenas",
                  title: "Arenas"
                }), React.createElement(SupSection.make, {
                  children: React.createElement(ContentSection.make, {
                        children: React.createElement("div", {
                              className: "grid grid-cols-1 md:grid-cols-2 justify-around items-center gap-8"
                            }, React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Code Break"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/boom_code_break.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "CTRL ALT DELETE!"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/boom_ctrl_alt_delete.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Light Gun Laser"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/boom_light_gun_laser.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })))
                      }),
                  id: "set-update-booms",
                  title: "Booms"
                }), React.createElement(SupSection.make, {
                  children: React.createElement(ContentSection.make, {
                        children: React.createElement("div", {
                              className: "grid grid-cols-1 md:grid-cols-2 justify-around items-center gap-8"
                            }, React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Bee Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_bee.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Coven Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_coven.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Cyberpunk Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_cyberpunk.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Dark Star Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_dark_star.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Forecast Janna Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_forecast_janna.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    }), React.createElement("iframe", {
                                      class: "rounded mt-6",
                                      width: screenSize === /* Xs */5 ? "320" : "440",
                                      height: screenSize === /* Xs */5 ? "180" : "247",
                                      src: "https://www.youtube.com/embed/QwXav4ur32A?si=KKLiTj9ozWZoP4cC",
                                      title: "Forecast Janna Portal",
                                      frameborder: "0",
                                      allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                      allowfullscreen: true
                                    })), React.createElement("div", undefined, React.createElement("h3", {
                                      className: "text-2xl font-montserrat font-medium pl-2 pb-2"
                                    }, "Project Portal"), React.createElement("img", {
                                      className: "rounded w-[320px] sm:w-[430px]",
                                      height: sizeHalf,
                                      src: "https://ap.tft.tools/img/cd14/portal_project.png?w=" + sizeHalf,
                                      width: sizeHalf
                                    }), React.createElement("iframe", {
                                      class: "rounded mt-6",
                                      width: screenSize === /* Xs */5 ? "320" : "440",
                                      height: screenSize === /* Xs */5 ? "180" : "247",
                                      src: "https://www.youtube.com/embed/68PD__fYq6c?si=RV6DPRI0bEUwj4DR",
                                      title: "Project Portal",
                                      frameborder: "0",
                                      allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                      allowfullscreen: true
                                    })))
                      }),
                  id: "set-update-portals",
                  title: "Portals"
                }), React.createElement(SupSection.make, {
                  children: React.createElement("div", {
                        className: "flex flex-col gap-12"
                      }, React.createElement("img", {
                            className: "rounded w-[305px] sm:w-[610px] md:w-[915px]",
                            height: "915",
                            src: "https://ap.tft.tools/img/cd14/Arcade Scribble.png?w=915",
                            width: "915"
                          }), React.createElement("img", {
                            className: "rounded w-[305px] sm:w-[610px] md:w-[915px]",
                            height: "915",
                            src: "https://ap.tft.tools/img/cd14/DoughCat.png?w=915",
                            width: "915"
                          }), React.createElement("img", {
                            className: "rounded w-[305px] sm:w-[610px] md:w-[915px]",
                            height: "915",
                            src: "https://ap.tft.tools/img/cd14/Knifepup.png?w=915",
                            width: "915"
                          }), React.createElement("img", {
                            className: "rounded w-[305px] sm:w-[610px] md:w-[915px]",
                            height: "915",
                            src: "https://ap.tft.tools/img/cd14/Mecha Chip.png?w=915",
                            width: "915"
                          }), React.createElement("img", {
                            className: "rounded w-[305px] sm:w-[610px] md:w-[915px]",
                            height: "915",
                            src: "https://ap.tft.tools/img/cd14/Shiro & Kuro.png?w=915",
                            width: "915"
                          })),
                  id: "set-update-tacticians",
                  title: "Tacticians"
                }));
}

var size = "152";

var size2 = "320";

var size2h = "180";

var arenaWidth = "768";

var arenaHeight = "432";

var make = SupTacticians;

export {
  size ,
  size2 ,
  size2h ,
  arenaWidth ,
  arenaHeight ,
  sizeHalf ,
  make ,
  
}
/* react Not a pure module */
